import { useIntl } from 'react-intl';
import { FormHelperTextProps, TextField } from '@material-ui/core';
import { MAX_SUBJECT_LENGTH } from './utils';
import * as Styles from './Orders.css';

interface OrderSubjectFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  // Translation keys; the label defaults to "subject (optional)".
  label?: string;
  help?: string;
  error?: string;
  size?: 'small' | 'medium';
}

// Optional subject of the order (decision of 02.10, after talking with Grant
// Thornton), up to 500 characters with a live counter.
const OrderSubjectField = ({
  id,
  value,
  onChange,
  label = 'ORDERS.SUBJECT_OPTIONAL',
  help,
  error,
  size,
}: OrderSubjectFieldProps) => {
  const intl = useIntl();
  const message = error || help;
  return (
    <TextField
      id={id}
      fullWidth
      multiline
      minRows={2}
      size={size}
      variant="outlined"
      label={intl.formatMessage({ id: label })}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={Boolean(error)}
      inputProps={{ maxLength: MAX_SUBJECT_LENGTH }}
      FormHelperTextProps={{ component: 'div' } as Partial<FormHelperTextProps>}
      helperText={
        <Styles.HelperRow>
          <span>{message ? intl.formatMessage({ id: message }) : ''}</span>
          <span>
            {intl.formatMessage(
              { id: 'ORDERS.SUBJECT_COUNTER' },
              { count: value.length, max: MAX_SUBJECT_LENGTH },
            )}
          </span>
        </Styles.HelperRow>
      }
    />
  );
};

export default OrderSubjectField;
